import React from "react";
import Modal from "../../../containers/Modal";
import {Grid, Col} from "../../../styles/Grid";
import {SelectStyled} from "../../../styles/Forms";
/* import Modal from "../containers/Modal";
import {Grid, Col} from "../styles/Grid";
import styled from "styled-components";
import {flexCreator} from "../hooks/helpers";
import {AppButton} from "../styles/Butttons";
import {SelectStyled} from "../../../styles/Forms"; */

export default function ModalNew({isOpen, close, theme, change}) {
   const readChange = (e) => {
      let num = Number(e.target.value);
      let prevv = ListCards.find((card) => card.num === num);
      let previw = prevv ? prevv.link : "/offer";
      let send = {
         link: `/offer/add/${num}`,
         prev: previw,
      };
      // console.log()
      change(send);
   };
   return (
      <Modal
         type="delete"
         isOpen={isOpen}
         close={() => {
            close();
         }}
         theme={theme}
      >
         <Grid>
            <Col large="6" offsetL={3}>
               <SelectStyled defaultValue={0} onChange={readChange}>
                  <option disabled value={0}>
                     Crear nuevo
                  </option>
                  <option value="1"> Cursos Esenciales</option>
                  <option value="2"> Certificado Prime</option>
                  <option value="5"> Certificado Masterclass</option>
                  <option value="3"> Programa Emblem</option>
               </SelectStyled>
            </Col>
         </Grid>
      </Modal>
   );
}

const ListCards = [
   {link: "/offer/cursos_esenciales", num: 1},
   {link: "/offer/certificado_prime", num: 2},
   {link: "/offer/programa_emblem", num: 3},
   {link: "/offer/certificado_prime", num: 5},
];
